import { render, staticRenderFns } from "./clueSources.vue?vue&type=template&id=63bb637c&scoped=true"
import script from "./clueSources.vue?vue&type=script&lang=js"
export * from "./clueSources.vue?vue&type=script&lang=js"
import style0 from "./clueSources.vue?vue&type=style&index=0&id=63bb637c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb637c",
  null
  
)

export default component.exports